






import { Component, Vue } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';

import * as _ from 'lodash';

if (window.LOGIN_CSS_BG) {
    document.documentElement.style.setProperty("--login-css-bg", window.LOGIN_CSS_BG);
}

@Component
export default class Index extends Vue {

    @Mutation('setLocation', { namespace: 'auth' })
    public setLocation: any;

    public async mounted() {
        await this.getLocation();
    }

    public async getLocation() {
        try {
            const { coords }: any = await this.getCurrentPosition();

            if (!coords) {
                return;
            }

            const { latitude, longitude } = coords;

            this.setLocation({
                latitude: _.ceil(latitude, 10),
                longitude: _.ceil(longitude, 10),
            });
        } catch (e) {
            window.console.warn(e);
        }
    }

    public getCurrentPosition() {
        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(resolve, reject, { enableHighAccuracy: true });
            }
        });
    }
}
